"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var _require = require('underscore'),
  chain = _require.chain,
  extend = _require.extend,
  findWhere = _require.findWhere,
  isArray = _require.isArray,
  isObject = _require.isObject,
  isString = _require.isString,
  sortBy = _require.sortBy;
angular.module('backstage.directives.externals').controller('AnyFpTypeComboWidgetCtrl', /* @ngInject */["$q", "$scope", "$filter", "$rootScope", "urlService", "eventService", "metadataService", "modalService", "backlinksService", "$timeout", "$element", function ($q, $scope, $filter, $rootScope, urlService, eventService, metadataService, modalService, backlinksService, $timeout, $element) {
  var scope = $scope;
  var LABEL_SEARCH_MINIMUM_INPUT_LENGTH = 0;
  var LEGACY_SEARCH_MINIMUM_RESULTS_FOR_SEARCH_BOX = 5;
  var options = scope.options || {};
  extend(scope, options);
  var idField = scope.idField = options.id_field || 'fp_ext_id';
  var cachedSortedItemList = scope.cachedSortedItemList = [];
  var cachedIdToNameMappings = scope.cachedIdToNameMappings = {};
  var promisedCache = {};
  var cachedIdToStatusMappings = {};
  var cachedIdToAssetMappings = {};
  var event = eventService.getCurrentEvent();
  var eventId = scope.eventId = event._id;
  var eventNode = event.node;
  var metadata = metadataService.getCachedMetadata(event._id);
  var allowedFpTypes = chain(options.allowed_types || {}).map(function (allowed, type) {
    if (allowed) {
      return type;
    }
  }).compact().value();

  // # # # #

  scope.selection = {
    fpType: null,
    fpExtId: null
  };
  scope.$watch('selection.fpType', function () {
    return scope.selection.fpExtId = null;
  });
  var filteredMetadataTypes = chain(metadata).pairs().filter(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      value = _ref2[1];
    if (!isObject(value) || key[0] === '_') {
      return false;
    }
    if (!allowedFpTypes.length) {
      return true;
    }
    return allowedFpTypes.indexOf(key) !== -1;
  }).map(function (_ref3) {
    var _ref4 = _slicedToArray(_ref3, 1),
      key = _ref4[0];
    return key;
  }).value();
  scope.fpTypeSelect2Options = {
    placeholder: 'Choose a type',
    data: metadataService.getTypeRepresentations(filteredMetadataTypes, metadata)
  };

  // BACKEND FEATURE DETECTION ⚑⚑⚑
  // use better remote-based externals search if we have a compatible pkg-lib-backlink

  var legacyModeDetectionPromise = backlinksService.isBacklinksSearchAvailable(eventId, eventNode).then(function (isBacklinksSearchAvailable) {
    scope.isInLegacyModeDetermined = true;
    if (scope.isInLegacyMode = !isBacklinksSearchAvailable) {
      return scope.select2Options = {
        placeholder: 'Choose an item',
        minimumResultsForSearch: LEGACY_SEARCH_MINIMUM_RESULTS_FOR_SEARCH_BOX
      };
    } else {
      // go remote
      return scope.select2Options = {
        placeholder: 'Find an item',
        minimumInputLength: LABEL_SEARCH_MINIMUM_INPUT_LENGTH,
        minimumResultsForSearch: LEGACY_SEARCH_MINIMUM_RESULTS_FOR_SEARCH_BOX,
        ajax: {
          url: function url() {
            return backlinksService.getSearchHandlerUrl(eventId, (scope.selection.fpType || {}).id);
          } /* params */,
          dataType: 'json',
          quietMillis: 250,
          data: function data(term) {
            // ' ' = return all
            if (term === null) {
              term = '';
            }
            return {
              query: term.length ? term : ' ',
              field: idField
            };
          },
          results: function results(list) {
            if (list === null) {
              list = [];
            }
            var field = $scope.model[$scope.field];
            if (field) {
              var ids = field;
              if (isObject(field[0])) {
                ids = field.map(function (o) {
                  return o.id || o._id || o.fp_ext_id;
                });
              }
              list = list.filter(function (i) {
                return !ids.includes(i.id || i._id || i.fp_ext_id);
              });
            }
            return {
              results: list
            };
          },
          cache: false
        }
      };
    }
  }, function () {
    // fall back to legacy mode on error
    scope.isInLegacyMode = true;
    scope.isInLegacyModeDetermined = true;
  });
  var getItemsArray = scope.getItemsArray = function () {
    var model = scope.model,
      field = scope.field;
    // set the default field value
    // if single_doc then this is null
    // or we'll set an empty array (to be filled with rows)

    var modelField = model[field];
    if (!modelField) {
      return [];
    } else {
      // add a warning if a list is expected, but value is not a list
      if (scope.single_doc) {
        if (!isObject(modelField)) {
          console.warn("Wrong value for field ".concat(field, ": ").concat(modelField, ". It should be an object."));
          modelField = model[field] = undefined;
        }
      } else {
        if (!isArray(modelField)) {
          console.warn("Wrong value for field ".concat(field, ": ").concat(modelField, ". It should be an array."));
          modelField = model[field] = [];
        }
      }
    }

    // now return the array of ids that we'll use to render the list
    if (scope.single_doc) {
      return [modelField];
    }
    return modelField;
  };
  var indexKeyForDoc = function indexKeyForDoc(doc) {
    if (isObject(doc)) {
      return "".concat(doc.fp_type, ":").concat(doc[idField]);
    }
    if (arguments.length === 2) {
      return "".concat(arguments[0], ":").concat(arguments[1]);
    }
  };
  var humanize = $filter('humanize');
  var uppercaseFirstChar = $filter('uppercaseFirstChar');
  scope.getFieldLabel = function () {
    var fieldLabel = scope.fieldDescriptor.label || scope.field;
    return uppercaseFirstChar(humanize(fieldLabel));
  };
  scope.canAddAnItem = function () {
    var currentNumber = getItemsArray().length;
    var maxNumber = scope.single_doc ? 1 : scope.options.maxNumber;
    return !maxNumber || currentNumber < maxNumber;
  };
  scope.getDisplayForId = function (fpType, fpExtId) {
    if (!fpExtId) {
      return;
    }
    var index = indexKeyForDoc(fpType, fpExtId);
    var promise = promisedCache[index];
    var cached = cachedIdToNameMappings[index];
    if (promise) {
      return promise;
    }
    if (cached) {
      var _id = (findWhere(cachedSortedItemList, _defineProperty({}, idField, fpExtId)) || {})._id;
      var result = {
        label: cached,
        id: _id
      };
      var _promise = Promise.resolve().then(function () {
        return result;
      });
      angular.extend(_promise, result);
      promisedCache[index] = _promise;
      return _promise;
    }
    var event = eventService.getCurrentEvent();
    var newPromise = promisedCache[index] = getItem(fpType, fpExtId).then(function (doc) {
      var reprLabel = metadataService.getReprLabelForItem(event._id, doc);
      var fallbackLabel = function fallbackLabel() {
        if (doc.fp_type === 'person') {
          return doc.fullname || "".concat(doc.fname, " ").concat(doc.lname);
        }
        return (doc.name || {}).en || doc.name || doc.title || doc.subject || doc.label || doc.fp_ext_id || doc._id;
      };
      var result = {
        label: reprLabel || fallbackLabel(),
        id: doc._id
      };
      angular.extend(newPromise, result);
      return result;
    });
    return newPromise;
  };
  function getItem(fpType, idOrFpExtId) {
    return $q.resolve().then(function () {
      if (idField === '_id') {
        return eventService.getEventDocById(event, idOrFpExtId).then(function (response) {
          return response.data || {};
        });
      }
      if (idField === 'fp_ext_id') {
        return eventService.getEventDocByFpExtId(event, idOrFpExtId, fpType);
      }
      return Promise.resolve({});
    });
  }
  scope.onItemClick = function (fpType, fpExtId) {
    if (!urlService.isValidAppRoute("/event/:eventId/".concat(fpType, "s/:modelId"))) {
      return null;
    }
    scope.getDisplayForId(fpType, fpExtId).then(function (display) {
      modalService.closeAll();
      $rootScope.navigate("/event/".concat(eventId, "/").concat(fpType, "s/").concat(display.id));
    });
  };
  scope.getIconClassForType = function (type) {
    switch (type) {
      case 'person':
      case 'presenter':
        return 'icon-user';
      case 'session':
        return 'icon-calendar';
      default:
        return 'icon-link';
    }
  };
  scope.getVisibilityClassesForId = function (fpExtId, enableStrikeThrough) {
    if (enableStrikeThrough === null) {
      enableStrikeThrough = true;
    }
    var strikethrough = enableStrikeThrough ? 'strikethrough' : '';
    switch (cachedIdToStatusMappings[fpExtId]) {
      case 'cancelled':
        return "translucent ".concat(strikethrough);
      case 'hidden':
        return 'translucent';
      default:
        return '';
    }
  };
  scope.revealAddDropdownControls = function () {
    if (scope.isInLegacyMode && (!cachedSortedItemList || !cachedSortedItemList.length)) {
      // if the list is empty we'll try to fetch again
      // (this is particularly useful when the user has just created a new item in a new tab/window and wants to see the list refresh)
      scope.loading = true;
      eventService.getEventDocsByType(event, scope.type).then(legacyGetEventDocsByTypeCb);
    }
    scope.showAddControls = true;
    $timeout(function () {
      $element.find('.btn-add-item').select2('open');
    }, 250);
  };
  var findRowIndex = function findRowIndex(rows, fpType, id) {
    for (var idx = 0; idx < rows.length; idx++) {
      var row = rows[idx];
      if (row.fp_type === fpType && row[idField] === id) {
        return idx;
      }
    }
    return -1;
  };
  scope.addFpExtId = function (fpType, fpExtId) {
    var ids = getItemsArray();
    if (!isString(fpExtId)) {
      return;
    }
    if (findRowIndex(ids, fpType, fpExtId) !== -1) {
      return;
    }
    var row = {};
    row.fp_type = fpType;
    row[idField] = fpExtId;
    var model = scope.model,
      field = scope.field;
    if (scope.single_doc) {
      model[field] = row;
    } else {
      if (!isArray(model[field])) {
        model[field] = [];
      }
      model[field].push(row);
    }
    scope.selection.fpType = null;
  };
  scope.removeFpExtId = function (fpType, fpExtId) {
    var model = scope.model,
      field = scope.field;
    var ids = getItemsArray();
    var idx = findRowIndex(ids, fpType, fpExtId);
    if (!ids || idx === -1) {
      return;
    }
    if (scope.single_doc) {
      model[field] = null;
    } else {
      ids.splice(idx, 1);
    }
  };
  var legacyGetEventDocsByTypeCb = function legacyGetEventDocsByTypeCb(evDocsListData) {
    var _list = evDocsListData ? evDocsListData.data : undefined;
    if (!_list) {
      return;
    }
    return fetchAndMapItems(_list);
  };
  var triggerLegacyModeFetchAndMapItems = function triggerLegacyModeFetchAndMapItems() {
    scope.loading = true;
    return eventService.getEventDocsByType(event, scope.type, {
      cached: true
    }).then(legacyGetEventDocsByTypeCb);
  };
  if (scope.isInLegacyModeDetermined) {
    if (scope.isInLegacyMode) {
      triggerLegacyModeFetchAndMapItems();
    }
  } else {
    legacyModeDetectionPromise.then(function () {
      if (scope.isInLegacyMode) {
        return triggerLegacyModeFetchAndMapItems();
      }
    });
  }
  var fetchAndMapItems = function fetchAndMapItems(docsList) {
    // ⚑ UNAVOIDABLE HACK ALERT
    // TODO: REMOVE this when we have fully transitioned away from hosted_docs
    docsList = docsList.map(function (_doc) {
      if (!_doc._id || _doc.fp_type !== 'hosted_doc') {
        return _doc;
      }
      var props = _doc.bs_fileprops;
      var ext = (props || {}).extension;
      if (!props || !ext) {
        return _doc;
      }
      if (_doc._id.substring(_doc._id.length - (ext.length + 1)) === ".".concat(ext)) {
        return _doc;
      }
      _doc._id = "".concat(_doc._id, ".").concat(ext);
      return _doc;
    });
    var idToNameMappings = docsList.reduce(function (memo, doc) {
      var reprLabel = metadataService.getReprLabelForItem(eventId, doc);
      var fallbackLabel = function () {
        switch (doc.fp_type) {
          case 'person':
            return doc.fullname || "".concat(doc.fname, " ").concat(doc.lname);
          default:
            return (doc.name ? doc.name.en : undefined) || doc.name || doc.title || doc.subject || doc.label || doc.fp_ext_id || doc._id;
        }
      }();
      memo[indexKeyForDoc(doc)] = reprLabel || fallbackLabel;
      return memo;
    }, {});
    angular.extend(cachedIdToNameMappings, idToNameMappings);
    var idToStatusMappings = docsList.reduce(function (memo, doc) {
      if (doc.fp_status) {
        memo[indexKeyForDoc(doc)] = doc.fp_status;
      }
      return memo;
    }, {});
    angular.extend(cachedIdToStatusMappings, idToStatusMappings);
    var filteredSortedItemList = $filter('filterOutPaxWithFpStatusCancelled')(sortBy(docsList, 'fname', 'title'));
    angular.copy(filteredSortedItemList, cachedSortedItemList);
    var idToAssetMappings = docsList.reduce(function (memo, doc) {
      if (doc.fp_asset) {
        memo[doc[idField]] = doc.fp_asset;
      }
      return memo;
    }, {});
    angular.extend(cachedIdToAssetMappings, idToAssetMappings);
    return scope.loading = false;
  };
}]);
angular.module('backstage.directives.externals').directive('bsAnyFpTypeComboWidget', function () {
  return {
    templateUrl: '/static/partials/components/any-fp-type-selector.html',
    require: '?ngModel',
    priority: 100,
    scope: {
      model: '=ngModel',
      fieldDescriptor: '=',
      field: '=',
      label: '=',
      options: '='
    },
    link: function link(scope, elem, attr, ctrl) {
      ctrl.$validators.required = function (modelValue, viewValue) {
        var isRequired = ((scope.fieldDescriptor || {}).validations || {}).required;
        return !(isRequired && ctrl.$touched && ctrl.$isEmpty(viewValue[scope.fieldDescriptor.field]));
      };
      scope.$watch('model[fieldDescriptor.field]', function (newValue, oldValue) {
        if (newValue !== undefined && oldValue !== newValue) {
          ctrl.$setTouched();
          ctrl.$validate();
        }
      });
    },
    controller: 'AnyFpTypeComboWidgetCtrl'
  };
});